import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import type {
	ADD,
	REMOVE,
} from '@atlassian/jira-software-add-comment-on-flag-action/src/ui/constants';
import type { OptimisticId } from '../../state/actions/meta/optimistic-ui-meta';
import type { GlobalIssueCreateInputs } from '../global-issue-create/types';
import type { Transition } from '../transition/types';
import type { CardId, CardForFlagWithCommentModal } from '../types';

export const MoveCardsActiveSprintType = 'MOVE_CARDS_ACTIVE_SPRINT' as const;

export type MoveCardsActiveSprint = {
	type: typeof MoveCardsActiveSprintType;
	payload: {
		originCardListName: string;
		destinationCardListName: string;
		cardIds: CardId[];
		confirmActionPayload: {
			cardIds: CardId[];
			cardListId: string;
			isBetweenLists: boolean;
			beforeCardId: CardId | null;
			afterCardId: CardId | null;
			targetStatusId?: string;
		};
		analyticsEvent: UIAnalyticsEvent;
	};
};

export const MoveCardsSelectTransitionType = 'MOVE_CARD_SELECT_TRANSITION' as const;

export type MoveCardsSelectTransition = {
	type: typeof MoveCardsSelectTransitionType;
	payload: {
		cardKeys: string[];
		transitions: Transition[];
		moveCardsActionPayload: {
			cardIds: CardId[];
			cardListId: string;
			isBetweenLists: boolean;
			beforeCardId: CardId | null;
			afterCardId: CardId | null;
		};
		optimisticId: OptimisticId;
		analyticsEvent: UIAnalyticsEvent;
	};
};

export const DeleteCardType = 'DELETE_CARD' as const;

export type DeleteCard = {
	type: typeof DeleteCardType;
	payload: {
		cardId: CardId;
	};
};

export const DeleteSprintType = 'DELETE_SPRINT' as const;

export type DeleteSprint = {
	type: typeof DeleteSprintType;
	payload: {
		sprintId: string;
	};
};

export const AssignIssueParentType = 'ASSIGN_ISSUE_PARENT' as const;

export type AssignIssueParent = {
	type: typeof AssignIssueParentType;
	payload: {
		cardIds: CardId[];
	};
};

export const GlobalIssueCreateType = 'GLOBAL_ISSUE_CREATE' as const;

export type GlobalIssueCreate = {
	type: typeof GlobalIssueCreateType;
	payload: GlobalIssueCreateInputs;
};

export const SplitIssueType = 'SPLIT_ISSUE_BACKLOG' as const;

export type SplitIssue = {
	type: typeof SplitIssueType;
	payload: {
		cardId: CardId;
	};
};

export const FlagWithCommentType = 'FLAG_WITH_COMMENT_BACKLOG' as const;

export type FlagWithComment = {
	type: typeof FlagWithCommentType;
	payload: {
		flagAction: typeof ADD | typeof REMOVE;
		cards: CardForFlagWithCommentModal[];
	};
};

export type ModalTypes =
	| typeof MoveCardsActiveSprintType
	| typeof DeleteCardType
	| typeof DeleteSprintType
	| typeof AssignIssueParentType
	| typeof GlobalIssueCreateType
	| typeof SplitIssueType
	| typeof MoveCardsSelectTransitionType
	| typeof FlagWithCommentType;

export type Modals =
	| MoveCardsActiveSprint
	| DeleteCard
	| DeleteSprint
	| AssignIssueParent
	| GlobalIssueCreate
	| SplitIssue
	| MoveCardsSelectTransition
	| FlagWithComment;
